import { defineStore } from "pinia";
import { IUserInfo, IOption, ISemester, ISubject, IGrade, IPeriod, IVersionInfo } from "@/type/common";
import { request } from "@/services";
import { MessageInstance } from "ant-design-vue/es/message";
import { IReviewPaper } from "@/type/review";
// 用户信息
export const useUserStore = defineStore("userInfo", {
  state: () => ({
    userInfo: {} as IUserInfo,
    visitedTasks: [] as string[], //访问过的结束任务
  }),
  getters: {
    getUserInfo: (state) => state.userInfo,
  },
  actions: {
    setUserInfo(userInfo: IUserInfo) {
      this.userInfo = userInfo;
    },
    logout() {
      // 退出登录
      this.userInfo = {} as IUserInfo;
      this.visitedTasks = [];
      const GlobalStore = useGlobalStore();
      GlobalStore.logout();
    },
  },
  persist: true,
});
// 全局属性，需缓存的数据
export const useGlobalStore = defineStore("global", {
  state: () => ({
    // 考试级别
    examLevel: [] as IOption[],
    // 考号类型
    examNumberType: [] as IOption[],
    // 考试类型
    examType: [] as IOption[],
    // 学年学期
    semester: [] as ISemester[],
    // 学科
    subjects: [] as ISubject[],
    // 年级
    grades: [] as IGrade[],
    // 操作子模块
    subModules: [] as IOption[],
    // 学段
    periods: [
      { name: "小学", code: 10 },
      { name: "初中", code: 20 },
      { name: "高中", code: 30 },
    ] as IPeriod[],
    periodObj: { 10: "小学", 20: "初中", 30: "高中" } as { [arg: number]: string },
    // 教师 id和name
    teachers: [] as { id: string; name: string }[],
    // 版本信息
    versionInfos: [] as IVersionInfo[],
    systemVersionNumber: "",
    systemVersionDate: "",
    fullScreen: false,
    ScrollNoitceShow: true,
  }),
  getters: {
    getCurrentSemesterId: (state) => (state.semester[0] ? state.semester[0].id : undefined),
    getExamNumberTypeOptions: (state) => state.examNumberType,
    getExamTypeOptions: (state) => state.examType,
    findExamNumberType: (state) => (code: string | number) => {
      return state.examNumberType.find((item:any) => item.code == code);
    },
    findExamType: (state) => (code: string) => {
      return state.examType.find((item:any) => item.code == code);
    },
    findExamLevel: (state) => (code: string | number) => {
      return state.examLevel.find((item:any) => item.code == code);
    },
    findSemester: (state) => (code: string) => {
      return state.semester.find((item:any) => item.code == code);
    },
    findGrade: (state) => (code: number | string) => {
      return state.grades.find((item:any) => item.code == code);
    },
    findPeriod: (state) => (code: number | string) => {
      return state.periods.find((period:any) => period.code == code);
    },
    filterSubject: (state) => (gradeCode: number) => {
      return state.subjects.filter((subject:any) => subject.gradeCode == gradeCode);
    },
    judgeOptionsIsNull: (state) => {
      return state.examLevel.length === 0;
    },
    judgeSemesterIsNull: (state) => {
      return state.semester.length === 0;
    },
    judgeSubjectIsNull: (state) => {
      return state.subjects.length === 0;
    },
    judgeGradeIsNull: (state) => {
      return state.grades.length === 0;
    },
  },
  actions: {
    logout() {
      this.examLevel = [];
      this.examNumberType = [];
      this.examType = [];
      this.semester = [];
      this.grades = [];
      this.subjects = [];
      this.teachers = [];
      this.subModules = [];
      this.ScrollNoitceShow = true;
      // this.$reset();
      // this.periods = [];
    },
    setFullScreen(state: boolean) {
      this.fullScreen = state;
    },
    setExamLevelOptions(examLevel: IOption[]) {
      this.examLevel = examLevel;
    },
    setExamNumberTypeOptions(examNumberType: IOption[]) {
      this.examNumberType = examNumberType;
    },
    setExamTypeOptions(examType: IOption[]) {
      this.examType = examType;
    },
    setSemesterOptions(semester: ISemester[]) {
      this.semester = semester;
    },
    setSubjectsOptions(subjects: ISubject[]) {
      this.subjects = subjects;
    },
    getFilterSubjects(gradeId: number) {
      return this.subjects.filter((item:any) => item.gradeCode == gradeId);
    },
    async getTeachers() {
      if (this.teachers.length === 0) {
        await request.get("/basics/teacher/get-all-map").then((res) => {
          if (res.code === 200) {
            this.teachers = res.data;
          }
        });
      }
      return this.teachers;
    },
  },
  persist: true,
});
// 阅卷模块
export const markingStore = defineStore("marking", {
  state: () => ({
    paperCaches: [] as IReviewPaper[],
  }),
  actions: {
    clearList() {
      // 清除list
      this.paperCaches = [];
    },
  },
});
